import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { get } from 'lodash';
import { Link } from '@bd/bdcore-named-routes';
import { menuToggler } from '@bd/bdcore-utilities';

import { colors } from '../../../styles';

const styles = css`
  .Menu_metroList {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    justify-content: space-between;
  }
  .Menu_metroListItem {
    flex-grow: 1;
    padding: 0 15px;
  }
  .Menu_metroListTitle {
    font-weight: 900;
    font-size: 17px;
    text-transform: uppercase;
    position: relative;
    border-bottom: 1px solid ${colors.brand2};
    padding: 0 0 10px;
    margin: 0 0 10px;
    cursor: pointer;
    display: block;
    transition: all .3s ease;
    &:hover {
      color: ${colors.brand2};
    }
  }
  .Menu_submetroList {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  .Menu_submetroListItem {
  }
  .Menu_submetroListItemLink {
    font-weight: 400;
    font-size: 17px;
    line-height: 1;
    padding: 10px 0;
    color: ${colors.brand1};
    display: block;
    &:hover {
      color: ${colors.brand2};
    }
  }
`;

function MenuItems({ areas, closeModal, submetroMenu, productMenu }) {
  return (
    <div className={styles}>
      <div>
        <ul className="Menu_metroList">
          {
            areas.filter(area => area.isMetro).map(metro => (
              <li className="Menu_metroListItem" key={metro.name}>
                <Link
                  name="communities"
                  params={{
                    communityMarketAreaMetro: get(metro, 'name'),
                  }}
                  onClick={() => closeModal()}
                  className="Menu_metroListTitle"
                >
                  {metro.name}
                </Link>
                {

                }
                {
                  submetroMenu &&
                  <ul className="Menu_submetroList">
                    {
                    areas.filter(area => area.parentMetro === metro.name).map(submetro => (
                      <li className="Menu_submetroListItem" key={submetro.name}>
                        <Link
                          name="communities"
                          params={{
                            communityMarketAreaMetro: get(metro, 'name'),
                            communityMarketAreaSubMetro: get(submetro, 'name'),
                          }}
                          className="Menu_submetroListItemLink"
                          onClick={() => closeModal()}
                        >
                          {submetro.name}
                        </Link>
                      </li>
                      ))
                    }
                  </ul>
                }
                {
                  productMenu &&
                  <ul className="Menu_submetroList">
                    <li className="Menu_submetroListItem">
                      <Link name="communities" params={{ communityMarketAreaMetro: get(metro, 'name') }} className="Menu_submetroListItemLink">Communities</Link>
                    </li>
                    <li className="Menu_submetroListItem">
                      <Link name="homes" params={{ communityMarketAreaMetro: get(metro, 'name') }} className="Menu_submetroListItemLink">Quick Move-In Homes</Link>
                    </li>
                    <li className="Menu_submetroListItem">
                      <Link name="plans" params={{ communityMarketAreaMetro: get(metro, 'name') }} className="Menu_submetroListItemLink">Available Plans</Link>
                    </li>
                    <li className="Menu_submetroListItem">
                      <Link name="model-homes" params={{ communityMarketAreaMetro: get(metro, 'name') }} className="Menu_submetroListItemLink">Model Homes</Link>
                    </li>
                    <li className="Menu_submetroListItem">
                      <Link name="open-houses" params={{ communityMarketAreaMetro: get(metro, 'name') }} className="Menu_submetroListItemLink">Open Houses</Link>
                    </li>
                    <li className="Menu_submetroListItem">
                      <Link name="build-on-your-lot" className="Menu_submetroListItemLink">Build On Your Lot</Link>
                    </li>
                    <li className="Menu_submetroListItem">
                      <Link name="special-offers" className="Menu_submetroListItemLink">Special Offers</Link>
                    </li>
                  </ul>
                }
              </li>
            ))
          }
        </ul>
      </div>
    </div>
  );
}

MenuItems.propTypes = {
  areas: PropTypes.arrayOf(PropTypes.object).isRequired,
  closeModal: PropTypes.func.isRequired,
  submetroMenu: PropTypes.bool,
  productMenu: PropTypes.bool,
};

MenuItems.defaultProps = {
  submetroMenu: false,
  productMenu: false,
};

export default withData(
  {
    areas: true,
  },
)(menuToggler((MenuItems)));



// WEBPACK FOOTER //
// ./src/components/Header/MenuModal/MenuItems.js